{
    "per_month": "Monat",
    "per_quarter": "Quartal",
    "per_year": "Jahr"
}
